import useChatStore from '@/stores/chat'
import { storeToRefs } from 'pinia'
import { genUuid } from '@/utils/index'
import { chatApi } from '@/api/chat'
import { onBeforeUnmount, nextTick } from 'vue'
import { cloneDeep } from 'lodash-es'
import { message } from 'ant-design-vue'
import { chatsMap } from '@/utils/constant'

// 发送消息前,更新最新回答的child_id
export const updateLastResponseChildId = () => {
    const chatStores = useChatStore()
    const { messageList, mapping } = storeToRefs(chatStores)
    const len = messageList.value.length - 1
    const tmpResponse = messageList.value[len]
    mapping.value[tmpResponse.message_id].child_id =
        mapping.value[tmpResponse.message_id].child_id || genUuid()
    chatStores.updateLastResponse(messageList.value[len])
}
const initFirstMap = (uuid) => {
    const chatStores = useChatStore()
    const child_id = genUuid()
    uuid = uuid || genUuid()
    const rootMap = {
        [uuid]: {
            content: '',
            message_type: 2, // 系统
            message_id: uuid,
            parent_id: null,
            child_id: child_id,
            active_page: 1,
            children: [child_id]
        }
    }
    chatStores.updateMapping(rootMap)
    chatStores.updateLastResponse(rootMap[uuid])
}
// 插入回答
export const appendSystemMessage = (
    content,
    extraParams = { isRegenerate: false, child_id: '' },
    itemParams = {}
) => {
    const chatStores = useChatStore()
    const { lastResponse, mapping } = storeToRefs(chatStores)
    const lastQuestion = mapping.value[lastResponse.value.child_id]
    if (extraParams.isRegenerate) {
        // 重新生成答案
        const message_id = lastQuestion.message_id
        lastQuestion.child_id = extraParams.child_id || genUuid()

        if (mapping.value[message_id].children[0]) {
            if (
                mapping.value[message_id].children[mapping.value[message_id].children.length - 1] !=
                lastQuestion.child_id
            ) {
                // 多次更新会导致页数不正确
                //    https://www.tapd.cn/63271158/prong/iterations/card_view/1163271158001000869?q=4a81eb73b12bb7a5ee6785955365b5a3&dialog_preview_id=bug_1163271158001024247
                mapping.value[message_id].children.push(lastQuestion.child_id)
                mapping.value[message_id].active_page = mapping.value[message_id].children.length
            }
        } else {
            mapping.value[message_id].children = [lastQuestion.child_id]
        }
    }
    const child_id = genUuid()
    const msgObj = {
        content: content,
        message_type: 2,
        text_type: 2,
        message_id: lastQuestion.child_id,
        parent_id: lastQuestion.message_id,
        child_id: child_id,
        active_page: 1,
        children: [child_id],
        is_stopped: 2,
        mark_status: 0,
        ...itemParams
    }
    mapping.value[msgObj.message_id] = msgObj
    chatStores.updateMapping(mapping.value)
}
// 插入表单
export const appendFormMessage = (extraParams: { isFirst: true; content: '' }) => {
    const chatStores = useChatStore()
    const { lastResponse, mapping } = storeToRefs(chatStores)
    if (!extraParams.isFirst) {
        // 重新创作
        const message_id = lastResponse.value.message_id
        lastResponse.value.child_id = genUuid()
        if (mapping.value[message_id].children[0]) {
            mapping.value[message_id].children.push(lastResponse.value.child_id)
            mapping.value[message_id].active_page = mapping.value[message_id].children.length
        } else {
            mapping.value[message_id].children = [lastResponse.value.child_id]
        }
    }
    const child_id = genUuid()

    // 重新编辑后,分页最后一个表单,对应的回答重新生成,extraParams.content
    const msgObj = {
        content: extraParams.content || '',
        message_type: 1,
        text_type: 2,
        message_id: lastResponse.value.child_id,
        parent_id: lastResponse.value.message_id,
        child_id: child_id,
        active_page: 1,
        children: [child_id],
        forms: extraParams.forms,
        originForms: cloneDeep(extraParams.forms),
        isPreview: extraParams.isFirst ? false : true,
        scene: extraParams.scene,
        is_form: 1,
        editCnt: extraParams.isFirst ? 0 : 1
    }
    mapping.value[msgObj.message_id] = msgObj
    chatStores.updateMapping(mapping.value)

    return msgObj
}

export const createSession = async (params, emit) => {
    const chatStores = useChatStore()
    const { curSelectSession, mapping, lastMessage, messageList } = storeToRefs(chatStores)
    if (!curSelectSession.value.session_id) {
        await chatApi
            .createSession({
                //  name: params.message,
                name: '新会话',
                session_id: ''
            })
            .then(
                (res: any) => {
                    const uuid = res.data.message_id
                    chatStores.updateCurSelectSession({
                        session_id: res.data.session_id,
                        session_name: params.message
                    })
                    if (emit) {
                        emit(
                            'refleshSession',
                            {
                                session_id: res.data.session_id,
                                session_name: params.message
                            },
                            true
                        )
                    }

                    if (Object.keys(mapping.value).length === 0) {
                        initFirstMap(uuid)
                    } else if (
                        Object.keys(mapping.value).length != 0 &&
                        messageList.value[1].is_form == 1
                    ) {
                        // 插入表单,点击立刻创作时
                        const tmpObj = cloneDeep(mapping.value[messageList.value[0].message_id])
                        delete mapping.value[messageList.value[0].message_id]
                        mapping.value[uuid] = {
                            ...tmpObj,
                            message_id: uuid
                        }
                        lastMessage.value.parent_id = uuid
                        chatStores.updateMapping(mapping.value)
                    }
                },
                (err) => {
                    message.error('会话创建失败!')
                }
            )
    }
}
export const useScene = (scene) => {
    // debugger
    // 场景卡片点击去使用

    const chatStores = useChatStore()

    let timer: any = null
    const { sendBoxRef, mapping, lastMessage, messageList } = storeToRefs(chatStores)
    if (chatStores.isSending) {
        message.info(chatsMap.sendingTips)
        return
    }
    const tailMessage = messageList.value[messageList.value.length - 1]
    if (tailMessage && tailMessage.is_form == 1 && tailMessage.editCnt == 0) {
        message.error('请使用当前表单进行创作后再添加新场景')
        return
    }
    if (scene.is_form == 1) {
        chatApi
            .getFormsBySceneId({
                id: scene.id
            })
            .then((res: any) => {
                if (Object.keys(mapping.value).length == 0) {
                    initFirstMap()
                } else {
                    updateLastResponseChildId()
                }

                appendFormMessage({ isFirst: true, scene: scene, forms: res.data.forms })
                nextTick(() => {
                    messageBoxScroll2Bottom()
                })
            })
    } else {
        if (sendBoxRef.value) {
            chatStores.updateIsSending(false)

            if (scene.is_form == 1) {
                // 表单
                sendBoxRef.value.sendMessage(scene.question, {
                    is_form: scene.is_form,
                    isFromScene: true,
                    forms: scene.forms
                })
            } else if (scene.is_form == 2) {
                // 非表单
                chatStores.updateSceneTxtExtraParams({
                    isFromScene: true
                })
                sendBoxRef.value.fillMessage(scene.question)
            }
        } else {
            timer = setInterval(() => {
                if (sendBoxRef.value) {
                    clearInterval(timer)
                    chatStores.updateIsSending(false)
                    if (scene.is_form == 1) {
                        sendBoxRef.value.sendMessage(scene.question, {
                            is_form: scene.is_form,
                            isFromScene: true,
                            forms: scene.forms
                        })
                    } else if (scene.is_form == 2) {
                        // sendBoxRef.value.fillMessage(scene.question)
                        chatStores.updateSceneTxtExtraParams({
                            isFromScene: true
                        })
                        sendBoxRef.value.fillMessage(scene.question)
                    }
                }
            }, 200)
        }
    }

    chatApi.useAssociateScene({
        id: scene.id
    })
    onBeforeUnmount(() => {
        clearInterval(timer)
    })
}
// map树转消息列表
export const formatMap2List = (mapping) => {
    // debugger
    const list = []
    const travers = (node) => {
        list.push(node)
        // if (node.child_id && node.children.length > 0) {
        if (mapping[node.child_id]) {
            travers(mapping[node.child_id])
        }
    }
    if (Object.keys(mapping).length > 0) {
        const root = Object.keys(mapping)
            .map((key) => mapping[key])
            .filter((item) => !item.parent_id)[0]
        travers(root)
    }
    return list
}
// 表单替换成问题
export const repalceForm2String = (finalForms, ControlType, props) => {
    const formValue2Replace: any = {}
    finalForms.map((item: any, idx: any) => {
        if (
            item.type == ControlType.textarea ||
            item.type == ControlType.slider ||
            item.type == ControlType.radio
        ) {
            formValue2Replace[idx + 1] = `${item.value}${item.tips}`
        } else if (item.type == ControlType.checkbox || item.type == ControlType.tags) {
            formValue2Replace[idx + 1] = item.value.join('、') + item.tips
        }
    })
    let modelPrompt = props.scene.prompt_question
    if (!modelPrompt) {
        return
    }
    Object.keys(formValue2Replace).forEach((key) => {
        const pattern: any = new RegExp(`\\{${key}\\}`, 'g')
        modelPrompt = modelPrompt.replace(pattern, formValue2Replace[key])
    })
    return modelPrompt
}
// 表单转换
export const formTransform = (finalForms, ControlType) => {
    const forms = cloneDeep(finalForms).map((item) => {
        if (item.type == ControlType.slider) {
            delete item.min
            delete item.max
            item.value = item.value.map((list) => {
                return list + ''
            })
        }
        return item
    })
    return forms
}
export const scrollToBottom = (hasBehaviour) => {
    const div = document.getElementById('msg_box')
    if (!div) return
    if (hasBehaviour) {
        div.classList.add('has-behavior')
    } else {
        div.classList.remove('has-behavior')
    }
    div.scrollTop = 70000 // 滚动到底部
}
export const stopSendIconClick = (modifyItemData = {}) => {
    // debugger
    const chatStores = useChatStore()
    const { mapping, lastResponse } = storeToRefs(chatStores)
    if (!chatStores.isResponseOk) {
        return
    }
    const lastQuestion = mapping.value[lastResponse.value.child_id]
    if (mapping.value[lastQuestion.child_id]) {
        mapping.value[lastQuestion.child_id].is_stopped = 1
    }
    // 普通问答终止还是营销问答终止
    if (mapping.value[lastQuestion.child_id].loadingType == 2) {
        mapping.value[lastQuestion.child_id].intention = 2
    } else if (mapping.value[lastQuestion.child_id]) {
        mapping.value[lastQuestion.child_id].intention =
            mapping.value[lastQuestion.child_id].intention == 2 ? 2 : 1
    }
    mapping.value[lastQuestion.child_id].loadingType = 0
    Object.keys(modifyItemData).forEach((key) => {
        mapping.value[lastQuestion.child_id][key] = modifyItemData[key]
    })

    if (chatStores.controller) {
        chatStores.controller.abort()
    }
    chatStores.updateIsSending(false)
}
// 聊天框滚动到底部
export const messageBoxScroll2Bottom = () => {
    const msg_end = document.getElementById('msg_end')
    if (msg_end) {
        msg_end.scrollIntoView(false)
    }
}
export const shouldDoScrollToBottom = () => {
    const chatStores = useChatStore()
    const { showScrollToBottom } = storeToRefs(chatStores)
    if (showScrollToBottom.value) {
        console.log('没有滑动到底部,shouldDoScrollToBottom fn被调用了---')
        messageBoxScroll2Bottom()
    }
}
